import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";
import Loader from "../Chargers/Loader";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import ReactPaginate from 'react-paginate';
import $ from 'jquery';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import { fetchStatusList } from "../../Apis/StatusListing";
import { useNavigate } from "react-router-dom";


function ReportDataExcel() {
  document.title = "Report Data Excel";

  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [userStatuses, setUserStatuses] = useState({});
  const [statusListing, setStatusListing] = useState([]);
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedLimit, setselectedLimit] = useState("");
  const [Limit, setLimit] = useState("10");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [fromDate, setFromDate] = useState('');
  const [ToDate,setToDate] = useState('');

  const handlefromDate = (e) => {
    setFromDate(e.target.value+" 00:00:00");
  };
  const handleToDate = (e) => {
    setToDate(e.target.value+" 23:59:59");
  }


  const [selectedUser, setSelectedUser] = useState('');
  const [selectedPaymentChange, setSelectedPaymentChange]  = useState('');
  
let navigate = useNavigate();


const handleReset = (event) => {
  event.preventDefault()
 navigate(`/report-excel`);
  }







  // Helper function for handling the select box change


  

  const handlePaymentChange = (e) => {
    setSelectedPaymentChange(e.target.value);
    // Optional: handle any additional logic, such as API calls to update status
  };

  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };
console.log("Pageeee",page)
  // Fetch Stations Data without search filter
  const FetchStationsData = async (currentPage, searchTerm = '') => {
    setLoading(true);
    const url = `${BaseURL}/excel-report/?page=${page}&searchText=${searchTerm}&from_date=${fromDate}&to_date=${ToDate}`;

    try {
      const res = await axios({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      console.log("reshghjgfhjgffff", res);
      if (res && res.data.data) {
        // setStationData(res.data.data);
        setFilteredData(res.data.data);
        setTotalCount(res.data?.totalCount || 0);
        setLimit(res?.data?.limit);
        setPageCount(Math.ceil(res.data.totalCount / 20));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchStationsData(page, searchQuery); // Pass current page and search query to the fetch function
  }, [page]);

  // Handle input change in search field
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };





  // Handle submit to fetch filtered data
  const handleSearchSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    // Check if the search query is empty
    if (!searchQuery.trim()) {
      // If no search query, call FetchStationsData to fetch all stations
      await FetchStationsData(page); // Ensure this function fetches all stations
      return; // Exit the function early
    }

    setLoading(true); // Set loading state to true while fetching

    const url = `${BaseURL}/excel-report?searchText=${searchQuery}&from_date=${fromDate} 00:00:00&to_date=${ToDate}23:59:59`;

    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`, // Include the authorization token
        },
      });

      if (res && res.data && res.data.data) {
        setFilteredData(res.data.data);
        setTotalCount(res.data.data.length); 
        setPageCount(Math.ceil(res?.data?.totalCount / 20)); 
      } else {
        setFilteredData([]); 
        setTotalCount(0); 
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false); // Set loading state to false after fetching
    }
  };

    console.log("Limit", Limit);
  const handleStatus = (e) => {
    setSelectedStatus(e.target.value);
  }
  const handleStatusType = async (event, userId) => {
    const status = event.target.value;
  
    // Update local state
    setUserStatuses(prevStatuses => ({
      ...prevStatuses,
      [userId]: status
    }));
  
    // URL for the updated endpoint
    const url = `${BaseURL}/razorpay/withdraw-change-status`;
  
    // Create JSON payload with withdraw_status and user_withdrawl_id
    const statusData = {
      withdraw_status: status,           // Send the updated status
      user_withdrawl_id: userId         // Send the userId as the withdrawal ID
    };
  
    try {
      // Send the request with updated data
      const response = await axios.post(url, statusData, {
        headers: {
          "Content-Type": "application/json", // Ensure it's sent as JSON
          Authorization: `Bearer ${uniqueToken}`, // Include the authorization token
        },
      });
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        console.log("Failed to update status", response.data);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  
console.log("filteredData", filteredData);
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header pb-0">
              <div className="row">
            <div className="row align-items-center">
  <div className="col-6">
    <h5 className="mb-0">Excel Report({totalCount? totalCount : "Loading..."})</h5>
  </div>
  <div className="col-6 text-right">
    <form
      onSubmit={handleSearchSubmit}
      className="d-flex align-items-center"
      style={{ justifyContent: "flex-end", width: "100%" }} // Ensure full width
    >
      <input
        placeholder="Find Data Here"
        className="form-control"
        style={{
          flex: 1, // Takes up remaining space
          maxWidth: "600px", // Define max width explicitly
          minWidth: "135px", // Ensure it doesn't shrink too much
          border: "1px solid black",
          marginRight: "10px", // Keeps spacing with the next element
          borderRadius: "34px",
          height: "38px",
        }}
        value={searchQuery}
        onChange={handleSearchChange}
      />

      <input
        type="text"
        className="form-control select2 select2-offscreen"
        onFocus={(e) => (e.target.type = "date")}
        onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
        placeholder="From Date"
        onChange={handlefromDate}
        style={{
          height: "38px",
          marginRight: "10px",
          width: "120px",
        }}
      />
      <input
        type="text"
        className="form-control select2 select2-offscreen"
        onFocus={(e) => (e.target.type = "date")}
        onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
        placeholder="To Date"
        onChange={handleToDate}
        style={{
          height: "38px",
          marginRight: "10px",
          width: "120px",
        }}
      />

      <button
        type="submit"
        className="btn btn-primary"
        style={{
          height: "38px",
          padding: "0 20px",
          borderRadius: "34px",
        }}
      >
        Search
      </button>
      <button
        type="submit"
        onClick={handleReset}
        className="btn btn-primary"
        style={{
          height: "38px",
          padding: "0 20px",
          borderRadius: "34px",
        }}
      >
        Reset
      </button>
    </form>
  </div>
</div>


              </div>
              <hr />
            </div>
            <div className="card-body">
              {loading ? (
                <Loader />
              ) : (
                <div className="card-body" style={{ marginLeft: "-19px" }}>
                  {loading ? (
                <h1>No data Found</h1>
                  ) : (
                    <>
                      <div className="table-responsive">

                        <table className="display dataTable" id="advance-1">
                          <thead>
                            <tr>
                              <th>Sr. No</th>
                              <th>File Name</th>
                               <th>Created Date</th>
                              
</tr>
                          </thead>
                          <tbody>
                            {filteredData?.length === 0 ? (
                              <tr>
                                <td colSpan="8" className="text-center">No Data Available</td>
                              </tr>
                            ) : (
                              filteredData?.map((u, index) => (
                                <tr key={index}>

                                  <td>{ index + 1}</td>
                                  <td>
  <a href={u?.fileURL} target="_blank">{u?.filename}</a>
</td>
<td>{u?.createdAt}</td>
                               </tr>
                              ))
                            )}
                          </tbody>
                        </table>

                      </div>

                      <div className="pagination-container mt-4">
                        <ReactPaginate
                          previousLabel={'Previous'}
                          nextLabel={'Next'}
                          breakLabel={'...'}
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageClick}
                          containerClassName={'pagination'}
                          subContainerClassName={'pages pagination'}
                          activeClassName={'active'}
                          forcePage={page - 1}
                        />
                      </div>
                    </>
                  )}
                </div>

              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportDataExcel;
